import Vue from "vue"
import VueRouter from "vue-router"
import Home from "../views/Home.vue"

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/about",
    name: "about",
    component: () => import("../views/About.vue"),
  },
  {
    path: "/introduce",
    name: "introduce",
    component: () => import("../views/introduce.vue"),
  },
  {
    path: "/service",
    name: "service",
    component: () => import("../views/service.vue"),
  },
  {
    path: "/cooperation",
    name: "cooperation",
    component: () => import("../views/cooperation.vue"),
  },
]

const router = new VueRouter({
  routes,
})

export default router
